<ng-template #tooltipTemplate>
  <div class="py-3">
    <div class="list-none w-full">
      <div class="flex gap-1 items-center justify-start w-full">
        <img
          *ngIf="!ngControl?.control?.errors?.['minlength'] && (ngControl.control && ngControl.control.value.length >= minlength)"
          src="./assets/icons/checked.svg"
          alt="Info Icon"
          class="w-3 h-3 text-gray-500"
        />
        <img
          *ngIf="(ngControl?.control?.errors?.['minlength'] && ngControl?.control?.errors?.['minlength']['actualLength'] !== minlength) || (ngControl.control && ngControl.control.value.length === 0)"
          src="./assets/icons/error.svg"
          alt="Info Icon"
          class="w-3 h-3"
        />
        <span class="text-sm">
          {{
            "shared.account_settings.password_validity.min_length" | transloco
          }}
        </span>
      </div>
      <div class="flex gap-1 items-center justify-start w-full">
        <img
          *ngIf="!ngControl?.control?.errors?.['noLettersOrNumbers']"
          src="./assets/icons/checked.svg"
          alt="Info Icon"
          class="w-3 h-3"
        />
        <img
          *ngIf="ngControl?.control?.errors?.['noLettersOrNumbers']"
          src="./assets/icons/error.svg"
          alt="Info Icon"
          class="w-3 h-3 text-gray-500"
        />
        <span class="text-sm">
          {{
            "shared.account_settings.password_validity.number_and_letters"
              | transloco
          }}
        </span>
      </div>
      <div class="flex gap-1 items-start justify-start w-full">
        <img
          *ngIf="!ngControl?.control?.errors?.['noUppercase'] && !ngControl?.control?.errors?.['noLowercase']"
          src="./assets/icons/checked.svg"
          alt="Info Icon"
          class="w-3 h-3 mt-[0.5px]"
        />
        <img
          *ngIf="ngControl?.control?.errors?.['noUppercase'] || ngControl?.control?.errors?.['noLowercase']"
          src="./assets/icons/error.svg"
          alt="Info Icon"
          class="w-3 h-3 mt-1"
        />
        <span class="text-sm whitespace-nowrap">
          {{
            "shared.account_settings.password_validity.upper_lower" | transloco
          }}
        </span>
      </div>
      <div class="flex gap-1 items-center justify-start w-full">
        <img
          *ngIf="!ngControl?.control?.errors?.['noSpecialChar']"
          src="./assets/icons/checked.svg"
          alt="Info Icon"
          class="w-3 h-3 text-gray-500"
        />
        <img
          *ngIf="ngControl?.control?.errors?.['noSpecialChar']"
          src="./assets/icons/error.svg"
          alt="Info Icon"
          class="w-3 h-3 text-gray-500"
        />
        <span class="text-sm">
          {{
            "shared.account_settings.password_validity.special_characters"
              | transloco
          }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<div
  [tooltip]="tooltipTemplate"
  triggers="focus"
  containerClass="tooltip-custom"
  [adaptivePosition]="false"
  placement="right"
  class="form-group relative"
  (mouseenter)="markAsTouched()"
>
  <input
    id="smart-password"
    class="w-full border border-gray-300 rounded p-2 relative"
    [type]="isPasswordVisible ? 'text' : 'password'"
    [value]="value"
    [disabled]="disabled"
    autocomplete="false"
    (input)="onInput($event)"
    [placeholder]="'shared.account_settings.enter_password' | transloco"
  />
  <span
    id="show-password"
    (click)="showPassword()"
    class="absolute inset-y-0 right-3 flex items-center cursor-pointer"
    aria-hidden="true"
  >
    <img
      *ngIf="isPasswordVisible"
      src="./assets/icons/eye.svg"
      alt="Info Icon"
      class="w-5 h-5 text-gray-500"
    />
    <img
      *ngIf="!isPasswordVisible"
      src="./assets/icons/crossed.svg"
      alt="Info Icon"
      class="w-5 h-5 text-gray-500"
    />
  </span>
</div>
